import Post from "../Post";

export default function userRegister(
  name,
  lastName,
  nationalCode,
  idCode,
  state,
  city,
  TOFM,
  email,
  phone
) {

  return Post("user/register", {
    name: name,
    lastName: lastName,
    nationalCode: nationalCode,
    IdCode: idCode,
    state: state,
    city: city,
    TOFM: TOFM,
    email: email,
    phone: phone,
  });
}
